/**
 * zarvia-promo-popup.js
 * Free shipping / mega sale popup — show frequency, evergreen countdown, close controls.
 */

(() => {
  'use strict';

  const STORAGE_PREFIX = 'zr-promo-popup';

  function shouldShow(popup) {
    const freq = popup.dataset.frequency;
    const key = `${STORAGE_PREFIX}:${popup.id}`;

    if (freq === 'every_visit') return true;
    if (freq === 'once_per_session') return !sessionStorage.getItem(key);
    if (freq === 'once_per_day') {
      const last = Number(localStorage.getItem(key));
      return !last || Date.now() - last > 24 * 60 * 60 * 1000;
    }
    if (freq === 'once_ever') return !localStorage.getItem(key);
    return true;
  }

  function markShown(popup) {
    const freq = popup.dataset.frequency;
    const key = `${STORAGE_PREFIX}:${popup.id}`;
    if (freq === 'once_per_session') sessionStorage.setItem(key, '1');
    if (freq === 'once_per_day' || freq === 'once_ever') localStorage.setItem(key, String(Date.now()));
  }

  function openPopup(popup) {
    popup.hidden = false;
  }

  function closePopup(popup) {
    popup.hidden = true;
  }

  function initCountdown(popup) {
    if (popup.dataset.countdownEnabled !== 'true') return;

    const hEl = popup.querySelector('[data-zr-promo-h]');
    const mEl = popup.querySelector('[data-zr-promo-m]');
    const sEl = popup.querySelector('[data-zr-promo-s]');
    if (!hEl || !mEl || !sEl) return;

    const hours = Number(popup.dataset.countdownHours) || 13;
    const autoRestart = popup.dataset.countdownRestart === 'true';
    const durationMs = hours * 60 * 60 * 1000;
    const key = `${STORAGE_PREFIX}:deadline:${popup.id}`;

    const render = (totalSeconds) => {
      const h = Math.floor(totalSeconds / 3600);
      const m = Math.floor((totalSeconds % 3600) / 60);
      const s = totalSeconds % 60;
      hEl.textContent = String(h).padStart(2, '0');
      mEl.textContent = String(m).padStart(2, '0');
      sEl.textContent = String(s).padStart(2, '0');
    };

    let deadline = Number(localStorage.getItem(key));

    if (!deadline || deadline < Date.now()) {
      if (deadline && !autoRestart) {
        render(0);
        return;
      }
      deadline = Date.now() + durationMs;
      localStorage.setItem(key, String(deadline));
    }

    const timer = setInterval(() => {
      let remainingMs = deadline - Date.now();

      if (remainingMs <= 0) {
        if (!autoRestart) {
          render(0);
          clearInterval(timer);
          return;
        }
        deadline = Date.now() + durationMs;
        localStorage.setItem(key, String(deadline));
        remainingMs = durationMs;
      }

      render(Math.floor(remainingMs / 1000));
    }, 1000);

    render(Math.floor((deadline - Date.now()) / 1000));
  }

  function initPopup(popup) {
    if (popup.dataset.zrPromoInited === 'true') return;
    popup.dataset.zrPromoInited = 'true';

    initCountdown(popup);

    const closeBtns = popup.querySelectorAll('[data-zr-promo-close]');
    const backdrop = popup.querySelector('[data-zr-promo-backdrop]');
    const closeOnBackdrop = popup.dataset.closeOnBackdrop === 'true';

    closeBtns.forEach((btn) => btn.addEventListener('click', () => closePopup(popup)));
    if (closeOnBackdrop) backdrop?.addEventListener('click', () => closePopup(popup));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !popup.hidden) closePopup(popup);
    });

    if (window.Shopify?.designMode) {
      /* Always preview instantly inside the theme editor, ignore frequency/delay */
      openPopup(popup);
      return;
    }

    if (!shouldShow(popup)) return;

    const delay = (Number(popup.dataset.delay) || 0) * 1000;
    setTimeout(() => {
      openPopup(popup);
      markShown(popup);
    }, delay);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-zr-promo-popup]').forEach(initPopup);
  });

  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-zr-promo-popup]').forEach((popup) => {
      popup.dataset.zrPromoInited = 'false';
      initPopup(popup);
    });
  });
})();
